import * as React from 'react';
import { Link } from "react-router-dom";
import { styled, alpha } from '@mui/material/styles';
// import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import ListItemButton from "@mui/material/ListItemButton";
import Grid from "@mui/material/Grid";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Banner from "../../assets/images/banner.svg";
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MailIcon from '@mui/icons-material/Mail';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import MuiAppBar from '@mui/material/AppBar';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useAppStore } from '../appStore';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import Tooltip from '@mui/material/Tooltip';
import DashboardIcon from '@mui/icons-material/Dashboard'; 
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import WbCloudyOutlinedIcon from "@mui/icons-material/WbCloudyOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";


import { useTheme } from '@mui/material/styles';

import { keyframes } from '@mui/material/styles';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

const AppBar = styled(MuiAppBar, {
    
  })(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
   
  }));

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const DrawerContainer = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor: "#ffff", // Blue color
  color: 'black',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  boxShadow: `0px 4px 8px rgba(0,0,0,0.3)`,
  animation: `${slideIn} 0.3s ease-out`,
}));
const smallContent = {
  typography: {
    fontFamily: "Roboto Flex",
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: "14px",
  },
  // Other styles...
};
const DrawerContent = styled(Drawer)(({ theme, open }) => ({
  '& .MuiDrawer-paper': {
    width: 240,
    // backgroundColor: '#007bff',
    color: '#ffffff',
    boxShadow: '0px 4px 8px rgba(0,0,0,0.3)',
    transition: 'transform 0.3s ease, opacity 0.3s ease',
    transform: open ? 'translateX(0)' : 'translateX(100%)',
    opacity: open ? 1 : 0,
    animation: open ? `${slideIn} 0.3s ease-out` : `${slideOut} 0.3s ease-out`,
  },
}));
const StyledMainBox = styled(Box)({
  backgroundColor: "#fff",
  padding: "19px",
  borderRadius: "15px",
  marginTop: "10px",
  //  width:"100%"
});
const ZoomOnHoverListItem = styled(ListItem)(({ theme }) => ({
  '&:hover': {
    transform: 'scale(1.05)',
    transition: 'transform 0.3s ease',
    backgroundColor: alpha(theme.palette.common.white, 0.2), // Optional: Add slight background color change on hover
  },
}));

export default function Navbar() {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const AUTHENTIK_LOGIN_URL =`${SERVER_URI}/ssologin`;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const [selectedItem, setSelectedItem] = React.useState("");
  const [totalBucketStorage, setTotalBucketStorage] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const updateOpen=useAppStore((state)=>state.updateOpen)
  const dopen=useAppStore((state)=>state.dopen)

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleItemClick = (itemName) => {
    setSelectedItem(itemName);
  };
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };
 
  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const menuId = 'primary-search-account-menu';
  // const renderMenu = (
  //   <Menu
  //     anchorEl={anchorEl}
  //     anchorOrigin={{
  //       vertical: 'top',
  //       horizontal: 'right',
  //     }}
  //     id={menuId}
  //     keepMounted
  //     transformOrigin={{
  //       vertical: 'top',
  //       horizontal: 'right',
  //     }}
  //     open={isMenuOpen}
  //     onClose={handleMenuClose}
  //   >
  //     <MenuItem onClick={() => {
  //       handleMenuClose();
  //       handleProfile();
  //     }}>
  //       <IconButton
  //         size="large"
  //         aria-label="account of current user"
  //         aria-controls="primary-search-account-menu"
  //         aria-haspopup="true"
  //         color="inherit"
  //       >
  //         <AccountCircle />
  //       </IconButton>
  //       <p>Profile</p>
  //     </MenuItem>
  //     <MenuItem onClick={() => {
  //       handleMenuClose();
  //       handleLogout();
  //     }}>
  //     <IconButton color="inherit" >
  //       <ExitToAppIcon />
  //     </IconButton>
  //     Logout
  //    </MenuItem>
  //   </Menu>
  // );
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#1a90ed" : "#308fe8",
    },
  }));
  const FILE_LIST = `${SERVER_URI}/list`;
  const [storageUnit, setStorageUnit] = React.useState(null);
  const [progressValue, setProgressValue] = React.useState(0);

  const totalstorage = 50;
  // Function to fetch file list and total bucket storage from the API
  const fetchFileListAndStorage = async () => {
    try {
      let token = localStorage.getItem("accessToken");
      const response = await fetch(FILE_LIST, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();

      const totalStorageWithUnit = data.totalBucketSize; // e.g., "173.66 MB"
      setTotalBucketStorage(totalStorageWithUnit);

      const parts = totalStorageWithUnit.split(" ");
      const unit = parts[1];
      setStorageUnit(unit);

      const usedStorage = parseFloat(data.totalBucketSize.replace(" MB", "")); // Replace this with the actual usedStorage value
      const progressValue = (usedStorage / 10000) * 50;

      setProgressValue(progressValue);
    } catch (error) {
      console.error("Error fetching file list:", error);
    }
  };

  // Fetch file list and total bucket storage when the component mounts
  React.useEffect(() => {
    const fetchData = async () => {
      await fetchFileListAndStorage();
    };
    fetchData();
  }, []);


  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
     
     <MenuItem onClick={() => {
        handleMenuClose();
        // handleLogout();
      }}>
      <IconButton color="inherit" >
        <ExitToAppIcon />
      </IconButton>
      Logout
     </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );
  const redirectToFiles = () => {
    // Navigate to the dashboard page when the button is clicked
    window.location.href="/files" // Replace '/dashboard' with the actual route to your dashboard
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" elevation={0} sx={{backgroundColor:"#ffffff", color:"#2f2f2f"}}>
        <Toolbar>
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            sx={{ mr: 2 }}
            onClick={()=>updateOpen(!dopen)}
          >
            <MenuIcon />
          </IconButton> */}
          {/* <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
           <strong>MegaConnect Cloud</strong> 
          </Typography> */}


        <Box
              sx={{
                display: "flex",
                // justifyContent: "center",
                alignItems: "center",
                padding: "10px",
                // "@media (max-width: 600px)": { display: "none" },
              }}
            >
              <img src={Banner} alt="" width={100} />
            </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
          {/* <Tooltip title="dashboad" arrow>
            <IconButton size="large" color="inherit" onClick={redirectToDashboard}>
            <DashboardCustomizeOutlinedIcon />
          </IconButton>
          </Tooltip> */}
          {/* <Tooltip title="settings" arrow>
            <IconButton size="large" aria-label="show 4 new mails" color="inherit" > */}
              {/* <Badge badgeContent={4} color="error">
                <MailIcon />
              </Badge> */}
              {/* <SettingsOutlinedIcon/>
            </IconButton>
            </Tooltip> */}
            {/* <Tooltip title="help" arrow>
              <IconButton
                size="large"
                aria-label="show 17 new notifications"
                color="inherit"
              >
                <HelpOutlineOutlinedIcon />
              </IconButton>
            </Tooltip> */}

            {/* <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton> */}
          </Box>
          {/* <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box> */}
          {isMobile && (
            <IconButton
              size="large"
              edge="start"
              color="#1D53E7"
              aria-label="open drawer"
              sx={{ mr: 2 }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {/* {renderMenu} */}

      <DrawerContent
        anchor="right"
        open={drawerOpen}
        onClose={handleDrawerToggle}
      >
              <StyledMainBox>
          <List>
          <ZoomOnHoverListItem button onClick={redirectToFiles}>
          <ListItem disablePadding sx={{ marginTop: "30px" }}>
            <ListItemButton
              component={Link}
              to="/files"
              selected={selectedItem === "Home"}
              onClick={() => handleItemClick("Home")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Home" ? "#1D53E7" : "#5D7285",
                }}
              >
                <HomeOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Home"
                style={{
                  color: selectedItem === "Home" ? "#488cca" : "#5D7285",
                  fontWeight: selectedItem === "Home" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
            </ZoomOnHoverListItem>
            <ZoomOnHoverListItem button >
            <ListItem disablePadding>
            <ListItemButton
              component={Link}
              // to="/overview"
              selected={selectedItem === "Recent"}
              onClick={() => handleItemClick("Recent")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Recent" ? "#1D53E7" : "#5D7285",
                }}
              >
                <ScheduleOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Recent"
                style={{
                  color: selectedItem === "Recent" ? "#488cca" : "#5D7285",
                  fontWeight: selectedItem === "Recent" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
            </ZoomOnHoverListItem>
            <ZoomOnHoverListItem button >
            <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/favorites"
              selected={selectedItem === "Favourite"}
              onClick={() => handleItemClick("Favourite")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Favourite" ? "#1D53E7" : "#5D7285",
                }}
              >
                <FavoriteBorderOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Favourite"
                style={{
                  color: selectedItem === "Favourite" ? "#488cca" : "#5D7285",
                  fontWeight: selectedItem === "Favourite" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
            </ZoomOnHoverListItem>
            <ZoomOnHoverListItem button >
            <ListItem disablePadding>
            <ListItemButton
              component={Link}
              to="/recyclebin"
              selected={selectedItem === "Recycle Bin"}
              onClick={() => handleItemClick("Recycle Bin")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Recycle Bin" ? "#1D53E7" : "#5D7285",
                }}
              >
                <DeleteOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Recycle Bin"
                style={{
                  color: selectedItem === "Recycle Bin" ? "#488cca" : "#5D7285",
                  fontWeight:
                    selectedItem === "Recycle Bin" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
            </ZoomOnHoverListItem>
            <ZoomOnHoverListItem button >
            <ListItem disablePadding>
            <ListItemButton
              component={Link}
              // to="/overview"
              selected={selectedItem === "Support"}
              onClick={() => handleItemClick("Support")}
              sx={{
                // backgroundColor:
                //   selectedItem === "Home" ? "#e9f5fe" : "transparent",
                // transition: "background-color 0.3s",
                "&:hover": {
                  // backgroundColor:
                  //   selectedItem !== "Home" ? "#1D53E7" : null,
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#1D53E7",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#1D53E7",
                  },
                },
                "&.Mui-selected": {
                  backgroundColor: "#e9f5fe",
                  "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                    color: "#488cca",
                  },
                },
                "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
                  color: "#131313",
                  fontFamily: "Roboto Flex", // Set font family to Roboto
                  fontSize: "1rem", // Set font size to 16px
                  lineHeight: "1.4", // Set line height to 1.4 (or 14px if you prefer pixel value)
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: selectedItem === "Support" ? "#1D53E7" : "#5D7285",
                }}
              >
                <HandshakeOutlinedIcon />
              </ListItemIcon>
              <ListItemText
                primary="Support"
                style={{
                  color: selectedItem === "Support" ? "#488cca" : "#5D7285",
                  fontWeight: selectedItem === "Support" ? "bold" : "normal",
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4",
                }}
              />
            </ListItemButton>
          </ListItem>
            </ZoomOnHoverListItem>
            {/* <ZoomOnHoverListItem button > */}
            <ListItem
            disablePadding
            sx={{
              display: "block",
              marginTop: "30px",
              backgroundColor: "#B7FFFE",
              borderRadius: "8px",
            }}
          >
            <ListItemButton
              sx={{
                // minHeight: 48,
                justifyContent: "center",
                px: 2.5,
                display: "block",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {/* Icon and Text (Storage Used) */}
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    display: "flex",
                    alignItems: "center",
                    mr: 2, // Space between icon and text
                  }}
                >
                  <WbCloudyOutlinedIcon sx={{ color: "#1D53E7" }} />
                  <Typography
                    sx={{
                      ...smallContent.typography,
                      color: "#1D53E7",
                      marginLeft: "8px", // Space between icon and text
                    }}
                  >
                    Storage Used
                  </Typography>
                </ListItemIcon>
              </Box>

              {/* Progress Bar and Storage Info */}
              {/* <Box> */}
              <Grid
                container
                direction="column"
                alignItems="left"
                justifyContent="left"
                sx={{ mt: 1, width: "100%" }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    // Margin on top of progress bar
                    color: "#1F1F1F",
                    fontFamily: "Roboto Flex",
                    fontSize: "1rem",
                    lineHeight: "18px",
                    fontWeight: 500,
                  }}
                >
                  {`${totalBucketStorage} of ${totalstorage}GB`}
                </Typography>
                {/* Progress Bar */}
                <BorderLinearProgress
                  variant="determinate"
                  value={progressValue}
                  sx={{ width: "100%", mt: 2, mb: 2 }} // Full width progress bar
                />

                {/* Storage Usage Reading */}
              </Grid>
              {/* </Box> */}
            </ListItemButton>
          </ListItem>

          {/* </ZoomOnHoverListItem> */}
          <ListItem
            disablePadding
            sx={{ mt: 2, backgroundColor: "#1D53E7", borderRadius: "24px",width:"100%" }}
          >
            <ListItemButton
              component={Link}
              to="/overview"
              // selected={selectedItem === "Back to Dashboard"}
              onClick={() => handleItemClick("Back to Dashboard")}
              sx={{
                color: "white",
                
              }}
            >
              <ListItemIcon
                sx={{
                  color: "white",
                }}
              >
                <DashboardCustomizeOutlinedIcon sx={{maxWidth:"40px"}} />
              </ListItemIcon>
              <ListItemText
                primary="Back to Dashboard"
                sx={{
                  color: "white",
                  fontWeight: 500,
                  fontFamily: "Roboto Flex",
                  fontSize: "1rem",
                  lineHeight: "1.4rem",
                  
                }}
              />
            </ListItemButton>
          </ListItem>
          </List>
          </StyledMainBox>
      </DrawerContent>
    </Box>
  );
}
